module.exports = __webpack_public_path__ + "static/img/metal11.164383c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metal11.jpg
// module id = Owzl
// module chunks = 0